import {PolymerElement} from '@polymer/polymer/polymer-element.js';
import {html} from '@polymer/polymer/lib/utils/html-tag.js';
import template from './ns-variant-details.html';

import {CartService} from '@nuskin/ns-shop';
import {events, RunConfigService, StringService} from '@nuskin/ns-util';

/**
 * Please put your variant details web component description here
 *
 * <ns-variant-details></ns-variant-details>
 */
export class NsVariantDetails extends PolymerElement {
    static get is() {
        return "ns-variant-details";
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
    htmlElement.innerHTML = template;
    return htmlElement;
    }

    static get properties() {
        return {
            sku: {
                type: String
            }
        }
    }

    constructor() {
        super();
    }

    ready() {
        super.ready();
        this.country = RunConfigService.getRunConfig().country;
        this.language = RunConfigService.getRunConfig().language;
        this._getCommonStrings();
    }

    // TODO: this is currently not being used
    tokenizeSku(sku) {
        var url = "";
        var part1 = sku.substring(0, 2);
        var part2 = sku.substring(2, 4);
        var part3 = sku.substring(4, 6);
        return part1 + "/" + part2 + "/" + part3 + "/" + sku;
    }

    removeItem() {
        var component = '#removeVariant' + this.sku;

        CartService.removeItemBySku(this.sku);
        events.publish(events.shop.ADD_TO_CART);
        events.publish(events.shop.OFFER_PRODUCTS_CHANGED);
        // For IE it doesn't understand the line below
        $(component).remove();
        // This is for browsers other than IE
        this.remove();
    }

    setVariantWidth() {
        if (!this.swatch) {
            return 'width: 100%';
        }
    }

    computeCost(price, qty) {
        return price * qty;
    }

    _getCommonStrings() {
        let inheritedStrings = [
                {key: "item", dflt: "Item"},
                {key: "quantity", dflt: "QTY"},
                {key: "price", dflt: "PRICE"}
            ];

        StringService.getStrings(inheritedStrings).then(strings => {
            this._setStrings(strings);
        });
    }

    _setStrings(strings) {
        this.itemLbl = strings.item;
        this.priceLbl = strings.price;
        this.qtyLbl = strings.quantity;
    }
}
customElements.define(NsVariantDetails.is, NsVariantDetails);
